import type {Track} from 'prolink-connect/lib/types';

export const idTrack = {
  title: 'ID',
  artist: {name: 'ID'},
} as Track;
